import { render } from "./Detail.vue?vue&type=template&id=7c2237bd&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=7c2237bd&scoped=true&lang=less"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2237bd"]])

export default __exports__